module.exports = __webpack_public_path__ + "img/maison11.962ddfdf.jpg";